module.exports = __webpack_public_path__ + "media/images/views/job_share/step-2-d68777a13f237063834ddc5eba226c8d.png";